import { combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import { compose, createStore, applyMiddleware } from 'redux';
import * as reducers from './modules';
import storage from 'redux-persist/lib/storage';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistStore, persistReducer } from 'redux-persist';
import thunk from 'redux-thunk';

import {
  seamlessImmutableReconciler,
  seamlessImmutableTransformCreator,
} from 'redux-persist-seamless-immutable';

const rootReducer = (state, action) => {
  if (action?.type === 'USER_LOGGED_OUT' || action?.type === 'SWITCH_ORGANIZATION') {
    const currentBastion = state?.auth?.currentBastion;
    const currentClient = state?.auth?.currentClient;
    const currentEmail = state?.auth?.currentEmail;
    const newState = combineReducers(reducers)(undefined, action);

    return {
      ...newState,
      auth: {
        ...newState.auth,
        currentBastion,
        currentClient,
        currentEmail,
      },
    };
  }
  return combineReducers(reducers)(state, action);
};

const persistConfig = {
  key: 'root',
  storage,
  stateReconciler: seamlessImmutableReconciler,
  whitelist: ['userSettings', 'auth'],
  blacklist: [],
  transforms: [seamlessImmutableTransformCreator({})],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const useReduxDevTools = true;

const middlewares = [thunk.withExtraArgument({})];

const enhancers = [];

enhancers.push(applyMiddleware(...middlewares));

const composer = useReduxDevTools ? composeWithDevTools : compose;

const store = createStore(persistedReducer, composer(...enhancers));

// TODO - Uncomment the following lines to use Redux Toolkit's configureStore instead of createStore

// Configure the store using Redux Toolkit
// const store = configureStore({
//   reducer: persistedReducer,
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       thunk: {
//         extraArgument: {},
//       },
//       serializableCheck: false, // Disable serializable check to work with redux-persist
//     }),
//   devTools: useReduxDevTools,
// });

export const persistor = persistStore(store);

const customState = {
  auth: {
    user: {},
    errors: {},
    bastions: [],
    loading: false,
    needsOTP: false,
    verifyOTP: false,
    fetchingUser: false,
    isAuthenticated: true,
    currentOrganization: {},
    organizations: {
      current: {},
      owned: [],
      services: [],
    },
    fetchedEmailConfirm: false,
    fetchedUpdateAccount: false,
    fetchingUpdateAccount: false,
    fetchingChangePassword: false,
    fetchChangePasswordSuccess: false,
    fetchedChangePasswordSuccess: false,
  },
};

// TODO - Uncomment the following lines to use Redux Toolkit's configureStore instead of createStore

// Update storeV2 to use configureStore
// export const storeV2 = (state) => {
//   // Check if state is a Redux store and extract its state if it is
//   const preloadedState = state && typeof state.getState === 'function' ? state.getState() : state;

//   return configureStore({
//     reducer: combineReducers(reducers),
//     preloadedState: Object.assign({}, customState, preloadedState),
//     middleware: (getDefaultMiddleware) =>
//       getDefaultMiddleware({
//         thunk: {
//           extraArgument: {},
//         },
//         serializableCheck: false,
//       }),
//     devTools: useReduxDevTools,
//   });
// };

export const storeV2 = (state) =>
  createStore(
    combineReducers(reducers),
    Object.assign({}, customState, state),
    composer(...enhancers)
  );

export default store;
